<template>
	<header>
		<div class="topTitle">
			<div class="logo" @click="openIndex">
				<img :src="logo" alt="">
			</div>
			<div class="title" >
				<div class="item" @mouseenter="secondAbout=false" :class="{hot:this.$store.state.isActive=='index'}" @click="openIndex">
					<span>首页</span>
				</div>
				<div class="item" @mouseenter="enterAbout()" :class="{hot:this.$store.state.isActive=='about'}">
					<span @click="openAbout">关于我们</span>
				</div>
				<div class="item" @mouseenter="enterLater()" :class="{hot:this.$store.state.isActive=='later'}">
					<span @click="openLater">后期全流程</span>
				</div>
				<div class="item" @mouseenter="enterWork()" :class="{hot:this.$store.state.isActive=='work'}">
					<span @click="openWork">作品展示</span>
				</div>
				<div class="item" @mouseenter="secondWork=false" :class="{hot:this.$store.state.isActive=='dynamic'}">
					<span @click="openDynamic">公司动态</span>
				</div>
				<div class="item" :class="{hot:this.$store.state.isActive=='join'}">
					<span @click="openJoin">加入我们</span>
				</div>
			</div>
			<!-- <div class="title">
			<div class="itemdiv">
				<div class="item" :class="{hot:this.$store.state.isActive=='index'}" @click="openIndex">
					<span>首页</span>
				</div>
			</div>
			<div class="itemdiv">
				<div class="item" :class="{hot:this.$store.state.isActive=='about'}">
					<span @click="openAbout">关于我们</span>
				</div>
				<div class="xialaBox" v-if="xialaHot==1">
					<div class="xialaItem" @click="laItem(11)">公司介绍</div>
					<div class="xialaItem" @click="laItem(12)">工作环境</div>
					<div class="xialaItem" @click="laItem(13)">联系我们</div>
				</div>
			</div>
			<div class="itemdiv">
				<div class="item" :class="{hot:this.$store.state.isActive=='later'}">
					<span @click="openLater">后期全流程</span>
				</div>
				<div class="xialaBox" v-if="xialaHot==2">
					<div class="xialaItem" @click="laItem(21)">声音制作</div>
					<div class="xialaItem" @click="laItem(22)">视觉效果</div>
					<div class="xialaItem" @click="laItem(23)">调光调色</div>
					<div class="xialaItem" @click="laItem(24)">数据管理</div>
					<div class="xialaItem" @click="laItem(25)">包装设计</div>
					<div class="xialaItem" @click="laItem(26)">后期统筹</div>
				</div>
			</div>
			<div class="itemdiv">
				<div class="item" :class="{hot:this.$store.state.isActive=='work'}">
					<span @click="openWork">作品展示</span>
				</div>
				<div class="xialaBox" v-if="xialaHot==3">
					<div class="xialaItem" @click="laItem(31)">
						电影
					</div>
					<div class="xialaItem" @click="laItem(32)">
						电视剧
					</div>
					<div class="xialaItem" @click="laItem(33)">网络剧</div>
					<div class="xialaItem" @click="laItem(34)">网络大电影</div>
				</div>
			</div>
			<div class="itemdiv">
				<div class="item" :class="{hot:this.$store.state.isActive=='dynamic'}">
					<span @click="openDynamic">公司动态</span>
				</div>
				<div class="xialaBox" v-if="xialaHot==4">
					<div class="xialaItem" @click="laItem(41)">新闻动态</div>
					<div class="xialaItem" @click="laItem(42)">获奖履历</div>
				</div>
			</div>
			<div class="itemdiv">
				<div class="item" :class="{hot:this.$store.state.isActive=='join'}">
					<span @click="openJoin">加入我们</span>
				</div>
				<div class="xialaBox" v-if="xialaHot==5">
					<div class="xialaItem" @click="laItem(51)">文化活动</div>
					<div class="xialaItem" @click="laItem(52)">招聘信息</div>
				</div>
			</div>
		</div> -->
			<a href="http://mail.amazingray.cn/" target="_blank" style="display: block;float: right;">
				<div class="mail">
					<span @click="mailtext=!mailtext">E-mail</span>
					<div class="icon" @click="mailtext=!mailtext">
						<img src="../assets/img/mail.png" mode=""></img>
					</div>
					<!-- <div v-if="mailtext" class="mailtext">{{companyMail}}</div> -->
				</div>
			</a>
		</div>
        <div class="secondMenu" @mouseleave="secondAbout=false" v-if="secondAbout">
			<ul>
				<li class="secondItem" @click="laItem(11)"><span>公司介绍</span></li>
				<li class="secondItem" @click="laItem(12)"><span>工作环境</span></li>
				<li class="secondItem" @click="laItem(13)"><span>联系我们</span></li>
			</ul>
		</div>
		<div class="secondMenu" @mouseleave="secondLater=false" v-if="secondLater">
			<ul>
				<li class="secondItem" @click="laItem(21)"><span>声音制作</span></li>
				<li class="secondItem" @click="laItem(22)"><span>视效制作</span></li>
				<li class="secondItem" @click="laItem(23)"><span>调光调色</span></li>
				<li class="secondItem" @click="laItem(24)"><span>数据管理</span></li>
				<li class="secondItem" @click="laItem(25)"><span>包装设计</span></li>
				<li class="secondItem" @click="laItem(26)"><span>后期统筹</span></li>
			</ul>
		</div>
		<div class="secondMenu" @mouseleave="secondWork=false" v-if="secondWork">
			<ul>
				<li class="secondItem" style="margin-right: 0.2rem;" @click="laItem(30)"><span>SHOWREEL</span></li>
				<li class="secondItem" @click="laItem(31)"><span>电影</span></li>
				<li class="secondItem" @click="laItem(32)"><span>电视剧</span></li>
				<li class="secondItem" @click="laItem(33)"><span>网络剧</span></li>
				<li class="secondItem" @click="laItem(34)"><span>网络大电影</span></li>
			</ul>
		</div>
	</header>
</template>

<script>
	export default {
		name: 'header',
		data() {
			return {
				logo: "",
				companyMail: "",
				mailtext: false,
				// aboutHot:false,
				// laterHot:false,
				// workHot:false,
				// dynamicHot:false,
				// joinHot:false,
				xialaHot: 0,
				//横板菜单的开关
				secondAbout:false,
				secondLater:false,
				secondWork:false,
			}
		},
		methods: {
			//横板菜单栏
			enterAbout(){
				this.secondAbout=true
				this.secondLater=false
				this.secondWork=false
			},
			enterLater(){
				this.secondAbout=false
				this.secondLater=true
				this.secondWork=false
			},
			enterWork(){
				this.secondAbout=false
				this.secondLater=false
				this.secondWork=true
			},
			//竖版菜单栏
			mouse() {
				let list = document.querySelectorAll('.itemdiv')
				console.log(list)
				let _this = this
				// pc端移入移出
				list[1].onmouseenter = function() {
					_this.xialaHot = 1
				}
				list[1].onmouseleave = function() {
					_this.xialaHot = 0
				}
				list[2].onmouseenter = function() {
					_this.xialaHot = 2
				}
				list[2].onmouseleave = function() {
					_this.xialaHot = 0
				}
				list[3].onmouseenter = function() {
					_this.xialaHot = 3
				}
				list[3].onmouseleave = function() {
					_this.xialaHot = 0
				}
				list[4].onmouseenter = function() {
					_this.xialaHot = 4
				}
				list[4].onmouseleave = function() {
					_this.xialaHot = 0
				}
				list[5].onmouseenter = function() {
					_this.xialaHot = 5
				}
				list[5].onmouseleave = function() {
					_this.xialaHot = 0
				}
				// 移动端移入移出
				// list[1].ontouchstart = function() {
				// 	_this.xialaHot = 1
				// }
				// list[1].ontouchend = function() {
				// 	_this.xialaHot = 0
				// }
				// list[2].ontouchstart = function() {
				// 	_this.xialaHot = 2
				// }
				// list[2].ontouchend = function() {
				// 	_this.xialaHot = 0
				// }
				// list[3].ontouchstart = function() {
				// 	_this.xialaHot = 3
				// }
				// list[3].ontouchend = function() {
				// 	_this.xialaHot = 0
				// }
				// list[4].ontouchstart = function() {
				// 	_this.xialaHot = 4
				// }
				// list[4].ontouchend = function() {
				// 	_this.xialaHot = 0
				// }
				// list[5].ontouchstart = function() {
				// 	_this.xialaHot = 5
				// }
				// list[5].ontouchend = function() {
				// 	_this.xialaHot = 0
				// }
			},
			//
			laItem(num) {
				console.log(num)
				if (num == 11) {
					this.$router.push({
						path: "/about",
						query: {
							num: 11
						}
					})
					this.$store.state.isActive = "about"
					localStorage.setItem("ishot", "about")
				} else if (num == 12) {
					this.$router.push({
						path: "/about",
						query: {
							num: 12
						}
					})
					this.$store.state.isActive = "about"
					localStorage.setItem("ishot", "about")
				} else if (num == 13) {
					this.$router.push({
						path: "/about",
						query: {
							num: 13
						}
					})
					this.$store.state.isActive = "about"
					localStorage.setItem("ishot", "about")
				} else if (num == 21) {
					this.$router.push({
						path: "/later",
						query: {
							num: 21
						}
					})
					this.$store.state.isActive = "later"
					localStorage.setItem("ishot", "later")
				} else if (num == 22) {
					this.$router.push({
						path: "/later",
						query: {
							num: 22
						}
					})
					this.$store.state.isActive = "later"
					localStorage.setItem("ishot", "later")
				} else if (num == 23) {
					this.$router.push({
						path: "/later",
						query: {
							num: 23
						}
					})
					this.$store.state.isActive = "later"
					localStorage.setItem("ishot", "later")
				} else if (num == 24) {
					this.$router.push({
						path: "/later",
						query: {
							num: 24
						}
					})
					this.$store.state.isActive = "later"
					localStorage.setItem("ishot", "later")
				} else if (num == 25) {
					this.$router.push({
						path: "/later",
						query: {
							num: 25
						}
					})
					this.$store.state.isActive = "later"
					localStorage.setItem("ishot", "later")
				} else if (num == 26) {
					this.$router.push({
						path: "/later",
						query: {
							num: 26
						}
					})
					this.$store.state.isActive = "later"
					localStorage.setItem("ishot", "later")
				} else if (num == 30) {
					this.$router.push({
						path: "/work",
						query: {
							num: 30
						}
					})
					this.$store.state.isActive = "work"
					localStorage.setItem("ishot", "work")
				} else if (num == 31) {
					this.$router.push({
						path: "/work",
						query: {
							num: 31
						}
					})
					this.$store.state.isActive = "work"
					localStorage.setItem("ishot", "work")
				} else if (num == 32) {
					this.$router.push({
						path: "/work",
						query: {
							num: 32
						}
					})
					this.$store.state.isActive = "work"
					localStorage.setItem("ishot", "work")
				} else if (num == 33) {
					this.$router.push({
						path: "/work",
						query: {
							num: 33
						}
					})
					this.$store.state.isActive = "work"
					localStorage.setItem("ishot", "work")
				} else if (num == 34) {
					this.$router.push({
						path: "/work",
						query: {
							num: 34
						}
					})
					this.$store.state.isActive = "work"
					localStorage.setItem("ishot", "work")
				} else if (num == 41) {
					this.$router.push({
						path: "/dynamic",
						query: {
							num: 41
						}
					})
					this.$store.state.isActive = "dynamic"
					localStorage.setItem("ishot", "dynamic")
				} else if (num == 42) {
					this.$router.push({
						path: "/dynamic",
						query: {
							num: 42
						}
					})
					this.$store.state.isActive = "dynamic"
					localStorage.setItem("ishot", "dynamic")
				} else if (num == 51) {
					this.$router.push({
						path: "/join",
						query: {
							num: 51
						}
					})
					this.$store.state.isActive = "join"
					localStorage.setItem("ishot", "join")
				} else if (num == 52) {
					this.$router.push({
						path: "/join",
						query: {
							num: 52
						}
					})
					this.$store.state.isActive = "join"
					localStorage.setItem("ishot", "join")
				}
			},
			//打开首页
			openIndex() {
				// this.ishot='index',
				this.$store.state.isActive = "index"
				this.$router.push({
					path: '/'
				})
				localStorage.setItem("ishot", "index")
			},

			openAbout() {
				// this.ishot='about',
				this.$router.push({
					path: '/about'
				})
				this.$store.state.isActive = "about"
				localStorage.setItem("ishot", "about")
			},

			openLater() {
				// this.ishot='later'
				this.$store.state.isActive = "later"
				this.$router.push({
					path: '/later'
				})
				localStorage.setItem("ishot", "later")
			},

			openWork() {
				this.$router.push({
					path: '/work'
				})
				this.$store.state.isActive = "work"
				localStorage.setItem("ishot", "work")
			},

			openDynamic() {
				this.$store.state.isActive = "dynamic"
				this.$router.push({
					name: 'dynamic'
				})
				localStorage.setItem("ishot", "dynamic")
			},

			openJoin() {
				this.$store.state.isActive = "join"
				this.$router.push({
					name: 'join'
				})
				localStorage.setItem("ishot", "join")
			},
			//获取首页其他信息,这里只获取logo
			getOther() {
				this.$api.get(this.$httpApi + this.$path.INDEX_DATALIST).then(res => {
					this.logo = res.data.data.logo; //公司logo
					this.companyMail = res.data.data.companyMail; //公司Email
					// console.log("公司logo",this.logo)
				}).catch(err => {})
			}
		},
		mounted() {
			this.getOther()
			this.mouse()
		}
	}
</script>

<style scoped>
	header {
		width: 19.20rem;
		height: 1.2rem;
		overflow: visible;
		position: relative;
		/* background-color: #05060A; */
	}

	.topTitle {
		width: 100%;
		height: 1.2rem;
		background-color: #05060A;
		padding: 0 1.4rem;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.logo {
		width: 2.09rem;
		height: 1.38rem;
		/* background-color: #00ff7f; */
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.logo img {
		width: 2.09rem;
		height: 0.51rem;
		display: block;
		/* background-color: #0055ff; */
	}

	.title {
		width: 12.80rem;
		height: 100%;
		padding: 0 0.90rem;
		box-sizing: border-box;
		font-weight: 400;
		/* background-color: #ff55ff; */
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.itemdiv {
		width: 1.8rem;
		height: 100%;
		float: left;
		display: flex;
		justify-content: space-around;
		align-items: center;
		position: relative;
		cursor: pointer;
	}

	.item {
		display: inline-block;
		width: auto;
		height: 0.58rem;
		display: flex;
		line-height: 1.38rem;
		/* font-size: 0.20rem; */
		font-size: 0.23rem;
		color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		/* background-color: #0000CD; */
		position: relative;
		border-bottom: 0.06rem solid #05060a;
	}

	.item:hover {
		/* color: #d30c1d; */
		border-bottom: 0.06rem solid #BA0303;
	}

	.xialaBox {
		width: 1.8rem;
		/* height: 1.8rem; */
		background-color: #05060a;
		border-radius: 0.05rem;
		position: absolute;
		top: 1.2rem;
		left: 0;
		z-index: 999;
		box-shadow: 0 0 0.1rem 0.01rem #666666;
	}

	.xialaItem {
		width: 100%;
		height: 0.6rem;
		text-align: center;
		font-weight: 400;
		font-size: 0.16rem;
		line-height: 0.6rem;
		color: #FFFFFF;
		border-bottom: 0.01rem solid #646464;
	}

	.xialaItem:hover {
		background-color: #d30c1d;
	}

	.xialaItem:last-child {
		border-bottom: none;
	}

	.hot {
		font-size: 0.23rem;
		/* color: #BA0303; */
		border-bottom: 0.06rem solid #BA0303;
	}

	.mail {
		width: 1.05rem;
		height: 100%;
		/* background-color: #2C3E50; */
		float: right;
		font-size: 0.20rem;
		text-align: left;
		line-height: 1.38rem;
		color: #FFFFFF;
		position: relative;
		cursor: pointer;
	}

	.mailtext {
		min-width: 1.05rem;
		height: 0.3rem;
		position: absolute;
		left: 0;
		bottom: 0.15rem;
		line-height: 0.3rem;
		color: #b1b1b1;
		font-size: 0.14rem;
		text-align: center;
	}

	.icon {
		width: 0.28rem;
		height: 0.21rem;
		position: absolute;
		right: 0;
		top: 0.57rem;
	}

	.icon img {
		width: 100%;
		height: 100%;
		display: block;
	}

	/* 二级横板下拉菜单 */
	.secondMenu {
		width: 100%;
		height: 0.4rem;
		background-color: rgba(0,0,0,0.4);
		position: absolute;
		bottom: -0.4rem;
		left: 0;
		z-index: 99;
	}
	ul{
		width: 100%;
		height: 100%;
		padding-left: 5.1rem;
		box-sizing: border-box;
	}
	.secondItem{
		width: 1.6rem;
		height: 100%;
		color: #FFFFFF;
		/* line-height: 0.4rem; */
		font-size: 0.2rem;
		line-height: 0.4rem;
		text-align: left;
		float: left;
	}
	.secondItem:hover{
		color: #ba0303;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/header.vue